import { useState } from 'react';
import { Alert, Button, Stack } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
  alert: { fontSize: '10pt' },
  alert_links: { color: 'white' }
};

DismissableAlert.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  data: PropTypes.object,
  action: PropTypes.node,
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end'])
};

export default function DismissableAlert(props) {
  const { children, disabled, action, alignItems, ...rest } = props;
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };

  if (disabled || !open) {
    return null;
  }

  const dismissButton = (
    <Button size="small" color="inherit" onClick={handleClose}>
      Dismiss
    </Button>
  );

  const combinedAction =
    action !== undefined ? (
      <Stack direction="row" spacing={1} alignItems="center">
        {action}
        {dismissButton}
      </Stack>
    ) : undefined;

  return (
    <Alert
      {...rest}
      action={combinedAction}
      onClose={combinedAction === undefined ? handleClose : undefined}
      sx={{
        '&': styles.alert,
        '& a': styles.alert_links,
        '&.MuiAlert-filledWarning': {
          backgroundColor: '#F8E4DE',
          color: '#663c00'
        },
        alignItems: alignItems || 'inherit'
      }}
    >
      {children}
    </Alert>
  );
}
